export default __webpack_public_path__ + "static/media/lc.6ac8de84.svg";